import Vue from 'vue';
import VueRouter from 'vue-router';
import axios from 'axios';

import Page404 from '../pages/404.vue';
import Policy from '../pages/Policy.vue'
import About from '../pages/About.vue'
import Members from '../pages/Members.vue'
import Main from '../pages/Main.vue'
import News from '../pages/News.vue'


import NotFoundPage from '../components/Common/NotFoundPage.vue';

import { DOMEN } from '../../vars';

Vue.use(VueRouter);
const routes = [
  {
    path: '/',
    name: 'IAAS',
    component: Main,
    meta: { title: 'СМУ МААН' },
  },
  {
    path: '/not-found',
    name: 'NotFoundPage',
    component: NotFoundPage,
    meta: { title: 'Страница не найдена' },
  },
  {
    path: '/privacy',
    name: 'Policy',
    component: Policy,
    meta: { requiresAuth: true, title: 'Политика в отношении обработки персональных данных' },
  },
  {
    path: '/about',
    name: 'About',
    component: About,
    meta: { requiresAuth: true, title: 'About CYS' },
  },
  {
    path: '/news',
    name: 'News',
    component: News,
    meta: { requiresAuth: true, title: 'News' },
  },
  {
    path: '/members',
    name: 'Members',
    component: Members,
    meta: { requiresAuth: true, title: 'Members' },
  },
  {
    path: '/404',
    name: '404',
    component: Page404
  },
  {
    path: '*',
    redirect: '/404'
  }
];

function wait(duration) {
  return new Promise((resolve) => setTimeout(resolve, duration));
}

async function tryScrollToAnchor(hash, timeout = 1000, delay = 100) {
  while (timeout > 0) {
    const el = document.querySelector(hash);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
      break;
    }
    await wait(delay);
    timeout = timeout - delay;
  }
}

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      // Required because our <RouterView> is wrapped in a <Transition>
      // So elements are mounted after a delay
      tryScrollToAnchor(to.hash, 1000, 100);
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }

    // console.log('scrollBehavior', to, from, savedPosition)
    // if (to.hash) {
    //   return {
    //     selector: to.hash,
    //   }
    // }
    
    // else{
    //   console.log('scrollBehavior 2', to, from, savedPosition)
    //   return { left: 0, top: 0 }
    //   // return { x: 0, y: 0 }
    // }
  },
});
const DEFAULT_TITLE = 'KCSNR User Portal';
router.afterEach((to, from) => {
  // Use next tick to handle router history correctly
  // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
  // console.log(from);
  Vue.nextTick(() => {
    document.title = to.meta.title || DEFAULT_TITLE;
    // const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
    // link.type = 'image/x-icon';
    // link.rel = 'shortcut icon';
    // link.href = DOMEN + '/media/static/page_logo_s.png';
    // document.getElementsByTagName('head')[0].appendChild(link);
  });
});
router.beforeEach(async (to, from, next) => {
  try {
    next();
  } catch (ex) {
    next();
  }
});


export default router;
